// extracted by mini-css-extract-plugin
export default {"discount-code-card":"DiscountCodeForm_discount-code-card__VByuV","input-container":"DiscountCodeForm_input-container__pdsnf"};